import {Tooltip, tooltipClasses, TooltipProps} from '@mui/material';
import {styled} from '@mui/material/styles';

export const ShippingAddressWrapper = styled('div')<{isReactNativeView?: boolean}>(({theme, isReactNativeView}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: isReactNativeView ? '4px' : '8px',
  border: isReactNativeView ? '0px' : '1px solid',
  borderColor: theme.palette.grey[100],
  borderRadius: isReactNativeView ? '0px 0px 8px 8px' : '8px',
  padding: isReactNativeView ? '8px' : '8px 12px',
  cursor: 'pointer',
  backgroundColor: theme.palette.common.white,
  ':hover': {
    backgroundColor: theme.palette.grey[100]
  }
}));

export const StyledTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} arrow classes={{popper: className}} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#000000 25%'
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000000 25%',
    padding: '16px',
    maxWidth: '343px'
  }
}));
